export enum ComputerStates {
    stopped = "Deallocated",
    stopping = "Deallocating",
    running = "Running",
    starting = "Starting",
    unknown = "Unknown"
}


// WEBPACK FOOTER //
// ./src/app/models/computerState.ts